import { MenuItem } from "@material-ui/core";
import React from "react";

// Planos que, por enquanto, se comportam exatamente como o Essencial.
// O "2026" (novo modelo de vendas, 22/09/2026) nasceu assim e será
// diferenciado depois — espelha SalesScope::PLANOS_COMO_ESSENCIAL na API.
export const PLANOS_COMO_ESSENCIAL = ["ESSENTIAL", "PLAN_2026"];

export const isLegacyFamilyPlan = familyPlan => {
  const newPlans = ["ESSENTIAL", "PLAN_2026", "PREMIUM", "EXCLUSIVE"];

  if (!familyPlan) {
    return false;
  }

  return !newPlans.includes(familyPlan);
};

export const isEssentialPlan = familyPlan => {
  if (!familyPlan) return false;

  return PLANOS_COMO_ESSENCIAL.includes(familyPlan);
};

export const getFamilyPlanOptions = (scope, filterProcessesNoCourtesy) => {
  const items = [];


    if (filterProcessesNoCourtesy.length > 0) {
      items.push(
        <MenuItem value="NONE" key="NONE">
          Plano Cidadão
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 3) {
      items.push(
        <MenuItem
          value="INITIAL_PORTUGUESE_FAMILY"
          key="INITIAL_PORTUGUESE_FAMILY"
        >
          Plano Origens
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 5) {
      items.push(
        <MenuItem value="SMALL_PORTUGUESE_FAMILY" key="SMALL_PORTUGUESE_FAMILY">
          Plano Sucessões
        </MenuItem>
      );
    }

    if (filterProcessesNoCourtesy.length >= 8) {
      items.push(
        <MenuItem value="BIG_PORTUGUESE_FAMILY" key="BIG_PORTUGUESE_FAMILY">
          Plano Gerações
        </MenuItem>
      );
    }

  items.push(
    <MenuItem value="ESSENTIAL" key="ESSENTIAL">
      Essencial
    </MenuItem>
  );

  // Plano "2026": escondido em producao ate as mudancas subsequentes
  // (contrato e perguntas proprias) estarem prontas. A opcao segue
  // visivel em staging (branch develop) para validacao.
  if (process.env.REACT_APP_PLANO_2026 === "1") {
    items.push(
      <MenuItem value="PLAN_2026" key="PLAN_2026">
        2026
      </MenuItem>
    );
  }

  items.push(
    <MenuItem value="PREMIUM" key="PREMIUM">
      Premium
    </MenuItem>
  );

  items.push(
    <MenuItem value="EXCLUSIVE" key="EXCLUSIVE">
      Exclusivo
    </MenuItem>
  );

  return items;
};

export const filterProcessesApensados = processes => {
  if (!Array.isArray(processes) || processes.length === 0) {
    return [];
  }

  return processes.filter(process => Boolean(process.apensado));
};
